module.exports = __webpack_public_path__ + "img/hindii-lang.55bb3d1a.svg";